(() => {
  'use strict';
  const translations = {
  "es": {
    "title": "Compara tu próximo par.",
    "intro": "Elige una variante de cada producto y revisa lo que cambia.",
    "caption": "Comparación de productos y especificaciones publicadas",
    "product": "Producto",
    "variant": "Presentación",
    "only_differences": "Mostrar solo diferencias",
    "difference_hint": "El color señala diferencias entre datos confirmados. Un dato pendiente no cuenta como diferencia.",
    "scroll_hint": "Desliza la tabla para ver todos los productos.",
    "loading": "Consultando especificaciones…",
    "error": "No pudimos cargar las especificaciones. Puedes revisar las variantes e intentarlo otra vez.",
    "retry": "Volver a intentar",
    "unknown": "Por confirmar",
    "pending": "Por confirmar",
    "unavailable": "Producto no disponible",
    "remove": "Quitar",
    "open": "Ver producto",
    "empty": "Aún no has elegido productos.",
    "empty_help": "Usa Comparar en el catálogo para añadir hasta tres productos.",
    "single": "Añade otro producto para ver sus diferencias.",
    "no_differences": "No hay diferencias confirmadas en las filas disponibles.",
    "price": "Precio de esta variante",
    "availability": "Disponibilidad",
    "available": "Disponible",
    "sold_out": "Agotado",
    "connection": "Conexión del paquete",
    "microphone": "Micrófono de esta variante",
    "mic_yes": "Con micrófono",
    "mic_no": "Sin micrófono",
    "manufacturer": "Datos del fabricante",
    "drivers": "Drivers por oído",
    "driver_size": "Tamaño del driver",
    "impedance": "Impedancia",
    "sensitivity": "Sensibilidad",
    "frequency": "Rango de frecuencia",
    "cable_connector": "Conector del auricular",
    "detachable": "Cable desmontable",
    "tuning": "Afinación o ajustes",
    "sources": "Fuentes y aclaraciones",
    "no_sources": "No hay ficha del fabricante verificada para este modelo.",
    "manufacturer_help": "Son datos declarados por el fabricante. Más drivers no significa mejor sonido.",
    "sensitivity_help": "La sensibilidad en dB sin referencia, dB/mW y dB/V no se compara directamente. Conservamos las unidades y condiciones de cada ficha.",
    "store_help": "Precio y disponibilidad corresponden a la variante seleccionada al cargar esta página. Confírmalos en la ficha antes de comprar.",
    "snapshot": "Prototipo: precio y disponibilidad corresponden al catálogo guardado, no a una consulta en vivo.",
    "tray": "Comparar",
    "tray_label": "Abrir comparación de {count} productos",
    "standard": "Única presentación",
    "checked": "Fuentes revisadas",
    "removed": "Producto retirado de la comparación.",
    "brand": "Marca",
    "type": "Tipo",
    "not_comparable": "Sin ficha comparable",
    "extended_help": "Las especificaciones ampliadas están disponibles para audífonos in ear.",
    "earphone_type": "Audífonos in ear"
  },
  "en": {
    "title": "Compare your next pair.",
    "intro": "Choose a variant for each product and see what changes.",
    "caption": "Product comparison and published specifications",
    "product": "Product",
    "variant": "Variant",
    "only_differences": "Show differences only",
    "difference_hint": "Shading marks differences between confirmed values. Missing data does not count as a difference.",
    "scroll_hint": "Scroll the table to see every product.",
    "loading": "Loading specifications…",
    "error": "We could not load specifications. You can review variants and try again.",
    "retry": "Try again",
    "unknown": "To be confirmed",
    "pending": "To be confirmed",
    "unavailable": "Product unavailable",
    "remove": "Remove",
    "open": "View product",
    "empty": "You have not selected any products yet.",
    "empty_help": "Use Compare in the catalogue to add up to three products.",
    "single": "Add another product to see differences.",
    "no_differences": "There are no confirmed differences in the available rows.",
    "price": "Selected variant price",
    "availability": "Availability",
    "available": "Available",
    "sold_out": "Sold out",
    "connection": "Package connection",
    "microphone": "Selected variant microphone",
    "mic_yes": "With microphone",
    "mic_no": "Without microphone",
    "manufacturer": "Manufacturer specifications",
    "drivers": "Drivers per ear",
    "driver_size": "Driver size",
    "impedance": "Impedance",
    "sensitivity": "Sensitivity",
    "frequency": "Frequency range",
    "cable_connector": "Earpiece connector",
    "detachable": "Detachable cable",
    "tuning": "Tuning or adjustments",
    "sources": "Sources and notes",
    "no_sources": "No verified manufacturer specification sheet is available for this model.",
    "manufacturer_help": "Specifications are manufacturer claims. More drivers does not mean better sound.",
    "sensitivity_help": "Sensitivity in dB without a reference, dB/mW and dB/V cannot be compared directly. We preserve each specification's units and conditions.",
    "store_help": "Price and availability reflect the selected variant when this page loaded. Confirm them on the product page before buying.",
    "snapshot": "Prototype: prices and availability come from the saved catalogue, not a live lookup.",
    "tray": "Compare",
    "tray_label": "Open comparison of {count} products",
    "standard": "Single option",
    "checked": "Sources reviewed",
    "removed": "Product removed from comparison.",
    "brand": "Brand",
    "type": "Type",
    "not_comparable": "No comparable specification sheet",
    "extended_help": "Extended specifications are available for in-ear earphones.",
    "earphone_type": "In-ear earphones"
  }
};
  const cache = new Map(), instances = new WeakMap();
  let sequence = 0;
  const fields = ['drivers','driver_size','impedance','sensitivity','frequency','cable_connector','detachable','tuning'];
  const externalIcon = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" aria-hidden="true" focusable="false" style="width:16px;height:16px;flex-shrink:0;vertical-align:-3px;fill:none;stroke:currentColor;stroke-width:1.75;stroke-linecap:round;stroke-linejoin:round"><path d="M7 17 17 7M7 7h10v10"/></svg>';
  const escape = value => String(value ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const normalized = value => String(value ?? '').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().trim();
  function safeURL(value, external=false) {
    try { const url = new URL(value, location.href); return (external ? url.protocol === 'https:' : ['http:','https:'].includes(url.protocol)) ? url.href : ''; } catch { return ''; }
  }
  function microphone(variant) {
    const title = normalized(variant?.title).replace(/[-_]/g,' ');
    if (/\b(?:sin|no|without)\s+(?:mic|microfono|microphone)\b|\bw\s*\/\s*o\s*mic\b/.test(title)) return 'mic_no';
    if (/\b(?:con|with)\s+(?:mic|microfono|microphone)\b/.test(title) || /^(mic|microfono|microphone)$/.test(title)) return 'mic_yes';
    return null;
  }
  function imageURL(product, variant) {
    const value = variant?.featured_image?.src || variant?.featured_image?.url || (typeof variant?.featured_image === 'string' ? variant.featured_image : '') || product.images?.find(image=>String(image.id)===String(variant?.image_id))?.src || (typeof product.featured_image === 'string' ? product.featured_image : product.featured_image?.src) || product.images?.[0]?.src || product.images?.[0];
    if (typeof value !== 'string') return '';
    const url = safeURL(value);
    if (!url) return '';
    const parsed = new URL(url);
    if (parsed.hostname === 'cdn.shopify.com') parsed.searchParams.set('width','400');
    return parsed.href;
  }
  async function load(url, retry=false) {
    if (retry) cache.delete(url);
    if (!cache.has(url)) cache.set(url, fetch(url).then(response=>{
      if (!response.ok) throw Error('comparison-data');
      return response.json();
    }).then(data=>{
      if (data.version !== 1 || !data.products || typeof data.products !== 'object') throw Error('comparison-schema');
      return data;
    }).catch(error=>{ cache.delete(url); throw error; }));
    return cache.get(url);
  }
  function mount(root, options) {
    const previous = instances.get(root);
    previous?.dispose();
    const locale = String(options.locale || 'es').startsWith('en') ? 'en' : 'es';
    const s = {...translations[locale], ...options.strings};
    const selected = previous?.selected || new Map();
    const prefix = previous?.prefix || 'bs-comparison-'+(++sequence);
    let products = options.products.slice(0,3), data = previous?.data || null, status = previous?.status || 'loading', differences = previous?.differences || false, disposed = false;
    const local = value => value && typeof value[locale] === 'string' && value[locale].trim() ? value[locale] : null;
    const variant = p => p.variants?.find(v=>String(v.id)===selected.get(p.handle)) || p.variants?.find(v=>v.available) || p.variants?.[0];
    const metadata = p => data?.products[p.handle];
    const price = v => { const raw=v?.price_cents ?? v?.price; return raw !== null && raw !== undefined && Number.isFinite(Number(raw)) && Number(raw)>=0 ? Number(raw) : null; };
    const value = (p,key) => {
      const v=variant(p);
      if (key==='brand') { const brand=metadata(p)?.brand || p.vendor; return brand && brand.trim()!=='--' ? brand : null; }
      if (key==='type') return metadata(p) ? s.earphone_type : p.type || p.product_type || null;
      if (p.unavailable || !v) return null;
      if (key==='price') return price(v);
      if (key==='availability') return typeof v.available==='boolean' ? (v.available?'available':'sold_out') : null;
      if (!metadata(p)) return null;
      if (key==='microphone') return microphone(v);
      if (key==='connection') return local(metadata(p)?.store?.connection);
      return local(metadata(p)?.specs?.[key]);
    };
    const isDifferent = key => new Set(products.map(p=>value(p,key)).filter(v=>v!==null).map(normalized)).size>1;
    const labelValue = (p,key) => {
      const v=value(p,key);
      if (status==='ready' && !metadata(p) && ['connection','microphone',...fields].includes(key)) return '<span class="bs-comparison-unknown">'+escape(s.not_comparable)+'</span>';
      if (v===null) return '<span class="bs-comparison-unknown">'+escape(status!=='ready'||key==='price'||key==='availability'||key==='microphone'||key==='connection'?s.pending:s.unknown)+'</span>';
      return escape(key==='price'?options.money(v):key==='availability'||key==='microphone'?s[v]:v);
    };
    function focusedControl(active) {
      if (!active) return null;
      if (active.hasAttribute('data-comparison-variant')) return {type:'variant',handle:active.dataset.comparisonVariant};
      if (active.hasAttribute('data-comparison-remove')) return {type:'remove',handle:active.dataset.comparisonRemove};
      if (active.hasAttribute('data-comparison-differences') || active.hasAttribute('data-comparison-retry')) return {type:'differences'};
      if (active.classList.contains('bs-comparison-open')) return {type:'open',handle:active.closest('[data-comparison-product]')?.dataset.comparisonProduct};
      if (active.hasAttribute('data-comparison-source')) return {type:'source',handle:active.dataset.comparisonSource,url:active.href};
      if (active.classList.contains('bs-comparison-scroll')) return {type:'scroll'};
      if (active.classList.contains('bs-comparison-empty')) return {type:'empty'};
      return null;
    }
    function render(focusKey) {
      if (disposed || !root.isConnected) return;
      const active=root.contains(document.activeElement)?document.activeElement:null;
      focusKey=focusKey||focusedControl(active);
      const scroll = root.querySelector('.bs-comparison-scroll')?.scrollLeft || 0;
      root.classList.add('bs-comparison');
      root.setAttribute('aria-busy',String(status==='loading'));
      if (!products.length) {
        root.innerHTML='<div class="bs-comparison-empty" tabindex="-1"><h2>'+escape(s.empty)+'</h2><p>'+escape(s.empty_help)+'</p></div>';
        if (focusKey) root.querySelector('.bs-comparison-empty').focus({preventScroll:true});
        return;
      }
      const row = key => {
        const different=isDifferent(key);
        if (differences && !different) return '';
        return '<tr data-comparison-row="'+key+'" class="'+(different?'is-different':'')+'"><th scope="row">'+escape(s[key])+'</th>'+products.map(p=>'<td'+(value(p,key)===null?' class="is-unknown"':'')+'>'+labelValue(p,key)+'</td>').join('')+'</tr>';
      };
      const extended=products.some(p=>metadata(p));
      const basicFields=['brand','type','price','availability'];
      const hasDifferences=[...basicFields,...(extended?['connection','microphone',...fields]:[])].some(isDifferent);
      root.innerHTML='<div class="bs-comparison-tools"><label><input type="checkbox" data-comparison-differences '+(differences?'checked':'')+'> '+escape(s.only_differences)+'</label><p>'+escape(s.difference_hint)+'</p></div>'+
        '<p class="bs-comparison-feedback" role="status">'+escape(status==='loading'?s.loading:products.length===1?s.single:differences&&!hasDifferences?s.no_differences:'')+'</p>'+
        (status==='error'?'<div class="bs-comparison-error" role="alert"><p>'+escape(s.error)+'</p><button type="button" data-comparison-retry>'+escape(s.retry)+'</button></div>':'')+
        '<p class="bs-comparison-scroll-hint">'+escape(s.scroll_hint)+'</p><div class="bs-comparison-scroll" tabindex="0" role="region" aria-label="'+escape(s.caption)+'"><table style="--comparison-count:'+products.length+'"><caption class="sr-only">'+escape(s.caption)+'</caption><thead><tr><th scope="col">'+escape(s.product)+'</th>'+
        products.map((p,index)=>{
          const v=variant(p),src=imageURL(p,v),url=!p.unavailable&&v?safeURL(options.productURL(p,v)):'';
          return '<th scope="col" data-comparison-product="'+escape(p.handle)+'"><div class="bs-comparison-product">'+(src?'<img src="'+escape(src)+'" alt="" width="400" height="400" loading="lazy">':'<div class="bs-comparison-no-image" aria-hidden="true"></div>')+
            '<h2>'+escape(p.unavailable?s.unavailable:p.title)+'</h2><button type="button" class="bs-comparison-remove" data-comparison-remove="'+escape(p.handle)+'" aria-label="'+escape(s.remove+': '+(p.title||p.handle))+'">'+escape(s.remove)+' <span aria-hidden="true">×</span></button>'+
            (!p.unavailable&&v?'<label for="'+prefix+'-variant-'+index+'">'+escape(s.variant)+'</label><select id="'+prefix+'-variant-'+index+'" data-comparison-variant="'+escape(p.handle)+'">'+p.variants.map(option=>'<option value="'+escape(option.id)+'" '+(option.id===v.id?'selected':'')+'>'+escape((option.title==='Default Title'?s.standard:option.title)+(!option.available?' — '+s.sold_out:''))+'</option>').join('')+'</select><a class="bs-comparison-open" href="'+escape(url)+'">'+escape(s.open)+' '+externalIcon+'</a>':'')+'</div></th>';
        }).join('')+'</tr></thead><tbody>'+basicFields.map(row).join('')+(extended?['connection','microphone'].map(row).join('')+
        '<tr class="bs-comparison-group"><th colspan="'+(products.length+1)+'">'+escape(s.manufacturer)+'</th></tr>'+fields.map(row).join(''):'')+'</tbody>'+(extended?'<tfoot><tr><th scope="row">'+escape(s.sources)+'</th>'+
        products.map(p=>{
          const meta=metadata(p), sources=(meta?.sources||[]).filter(source=>safeURL(source.url,true));
          return '<td><div class="bs-comparison-sources">'+(sources.length?sources.map(source=>'<a data-comparison-source="'+escape(p.handle)+'" href="'+escape(safeURL(source.url,true))+'" target="_blank" rel="noopener noreferrer">'+escape(source.title||source.url)+' '+externalIcon+'</a>').join(''):'<p class="bs-comparison-unknown">'+escape(!meta?s.not_comparable:status==='ready'?s.no_sources:s.pending)+'</p>')+
            ((meta?.notes||[]).length?'<ul>'+meta.notes.map(note=>local(note)).filter(Boolean).map(note=>'<li>'+escape(note)+'</li>').join('')+'</ul>':'')+'</div></td>';
        }).join('')+'</tr></tfoot>':'')+'</table></div><div class="bs-comparison-explainer">'+(extended?'<p>'+escape(s.manufacturer_help)+'</p><p>'+escape(s.sensitivity_help)+'</p>':status==='ready'?'<p>'+escape(s.extended_help)+'</p>':'')+'<p>'+escape(options.snapshot?s.snapshot:s.store_help)+'</p>'+(extended&&data?.checked_at?'<small>'+escape(s.checked)+': '+escape(String(data.checked_at).slice(0,10))+'</small>':'')+'</div>';
      root.querySelector('.bs-comparison-scroll').scrollLeft=scroll;
      if (focusKey) {
        const target=focusKey.type==='scroll'?root.querySelector('.bs-comparison-scroll'):
          focusKey.type==='variant'?[...root.querySelectorAll('[data-comparison-variant]')].find(el=>el.dataset.comparisonVariant===focusKey.handle):
          focusKey.type==='remove'?[...root.querySelectorAll('[data-comparison-remove]')].find(el=>el.dataset.comparisonRemove===focusKey.handle):
          focusKey.type==='open'?[...root.querySelectorAll('[data-comparison-product]')].find(el=>el.dataset.comparisonProduct===focusKey.handle)?.querySelector('.bs-comparison-open'):
          focusKey.type==='source'?[...root.querySelectorAll('[data-comparison-source]')].find(el=>el.dataset.comparisonSource===focusKey.handle&&el.href===focusKey.url):null;
        (target||root.querySelector('[data-comparison-differences]'))?.focus({preventScroll:true});
      }
    }
    async function refresh(retry=false) {
      if (!products.length) { status='ready'; render(); return; }
      status='loading'; render();
      try { data=await load(options.dataUrl,retry); status='ready'; } catch { status='error'; }
      if (!disposed) render();
    }
    function change(event) {
      const select=event.target.closest('[data-comparison-variant]');
      if (select) { selected.set(select.dataset.comparisonVariant,select.value); render({type:'variant',handle:select.dataset.comparisonVariant}); }
      else if (event.target.matches('[data-comparison-differences]')) { differences=event.target.checked; render({type:'differences'}); }
    }
    function click(event) {
      const remove=event.target.closest('[data-comparison-remove]');
      if (remove) {
        const handle=remove.dataset.comparisonRemove, index=products.findIndex(p=>p.handle===handle);
        products=products.filter(p=>p.handle!==handle); selected.delete(handle);
        const next=products[Math.min(index,products.length-1)];
        render(next?{type:'remove',handle:next.handle}:{type:'empty'});
        options.onRemove?.(handle);
      }
      if (event.target.closest('[data-comparison-retry]')) refresh(true);
    }
    root.addEventListener('change',change);root.addEventListener('click',click);
    const controller={selected,prefix,get data(){return data;},get status(){return status;},get differences(){return differences;},dispose(){disposed=true;root.removeEventListener('change',change);root.removeEventListener('click',click);}};
    instances.set(root,controller);refresh();return controller;
  }
  function tray(element,{count,url,locale='es',hidden=false,strings={}}) {
    if (!element) return;
    const s={...translations[locale.startsWith('en')?'en':'es'],...strings};
    element.hidden=hidden||count===0;
    element.href=url;
    element.setAttribute('aria-label',s.tray_label.replace('{count}',String(count)));
    element.textContent=s.tray+' ('+count+')';
  }
  window.BSComparison={mount,tray,strings:translations};
})();

